import { CountryCode, getCountries } from "libphonenumber-js";

export type Country = {
  code: CountryCode;
  name: string;
};

const countryDisplayNames = new Intl.DisplayNames(["en"], { type: "region" });

export const COUNTRIES: Country[] = getCountries()
  .map((code) => ({ code, name: countryDisplayNames.of(code) ?? code }))
  .sort((a, b) => a.name.localeCompare(b.name));

const DEFAULT_COUNTRY: CountryCode = "US";

export const getBrowserDefaultCountry = (): CountryCode => {
  try {
    const region = new Intl.Locale(navigator.language).maximize().region;
    return region && getCountries().includes(region as CountryCode)
      ? (region as CountryCode)
      : DEFAULT_COUNTRY;
  } catch {
    return DEFAULT_COUNTRY;
  }
};
